import { getShortFormat, getLocaleFormat } from "../../../../../utils/numbers";
import { getStringAsCurrency } from "../../../../../utils/currency";
export default function Currency(params) {
  let {
    value,
    otherFields,
    locale
  } = params;
  if (!value && value !== 0) return null;

  //TODO use currencyFromData and currencyFromLocale and depending on that,
  //use the data currency or get the currencyISO from locale in order to get the right symbol

  let finalValue = value;
  const currencySymbol = params.data[otherFields === null || otherFields === void 0 ? void 0 : otherFields.symbol] || '';
  const currencyCell = document.createElement('div');
  currencyCell.classList.add('w5-currency-cell');
  if (!finalValue) value = 0;
  if (otherFields !== null && otherFields !== void 0 && otherFields.longFormat) {
    finalValue = getLocaleFormat(finalValue, locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: otherFields === null || otherFields === void 0 ? void 0 : otherFields.digits
    });
  } else {
    finalValue = getShortFormat(finalValue, locale, otherFields === null || otherFields === void 0 ? void 0 : otherFields.digits);
  }
  finalValue = getStringAsCurrency(finalValue, currencySymbol);
  currencyCell.innerText = finalValue;
  return currencyCell;
}